/* eslint-disable no-unused-vars */
import DataTable from '@/containers/data_table_ml/DataTable';
import styles from './TablePage.less?modules';
import ButtonML from '@/components/button_ml/ButtonML';
// import { CONSTANT } from '../../constant/index';
import { useTrigger } from '@/utils/comHook.js';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import { Menu } from 'antd';
import Dropdown from '../dropdown_ml2/Dropdown';

const TablePage = (props) => {
  const {
    loading,
    edit,
    pushLog,
    pushDecisionGraphMap,
    deleteItem,
    tableData,
    getVersion,
    handleMenuClick,
    menuList,
  } = props || {};
  // const [name,setName] = useState('');
  const handleMemberDelete = (record) => {
    deleteItem(record);
  };
  const deleteTrigger = useTrigger();

  const showVersion = (e, i) => {
    getVersion(e, i);
  };
  let menu = <Menu onClick={handleMenuClick}>{menuList}</Menu>;

  const columns = [
    {
      title: '决策图名称',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (recor, detail) => {
        return (
          <ButtonML
            type="link"
            size="large"
            value={recor}
            onClick={() => pushDecisionGraphMap(detail)}
          />
        );
      },
    },
    {
      title: '决策图编号',
      dataIndex: 'code',
      key: 'code',
      width: 60,
    },
    {
      title: '版本号',
      dataIndex: 'version',
      key: 'version',
      width: 50,
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
      width: 150,
    },
    {
      title: '操作人员',
      dataIndex: 'operatorStaff',
      key: 'operatorStaff',
      width: 60,
    },
    {
      title: '起始节点',
      dataIndex: 'startNode',
      key: 'startNode',
      width: 60,
      align: 'center',
    },
    {
      title: '结束节点',
      dataIndex: 'endNode',
      key: 'endNode',
      width: 60,
      align: 'center',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 100,
      align: 'center',
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 100,
      align: 'center',
    },
    {
      title: '操作',
      render: (recor, recorUnuse, index) => {
        return (
          <div className={styles.handle_btn}>
            <ButtonML
              size="large"
              value="编辑"
              disabled={!recor.editable}
              onClick={() => edit(recor)}
            />
            <ModalConfirmML
              title="是否确认删除?"
              handleOk={() => handleMemberDelete(recor)}
              handleCancel={deleteTrigger.close}
              visible={deleteTrigger.visible}
              value="删除"
              disabled={!recor.editable}
              icon={<ExclamationCircleOutlined />}
            />
            <Dropdown
              size="large"
              title="选择版本"
              fontsize="14px"
              item={recor}
              index={index}
              menu={menu}
              clickButton={showVersion}
            />
            <ButtonML
              size="large"
              value="操作日志"
              onClick={() => pushLog(recor)}
            />
          </div>
        );
      },
      width: 300,
    },
  ];
  return (
    <>
      <DataTable
        className="demo-test"
        // style={{ minWidth: '1547px' }}
        columns={columns}
        rowSelection={false}
        // pagination={pagination}
        scroll={{ x: 1547, y: 'calc(100vh - 156px - 3rem)' }}
        loading={loading}
        dataSource={tableData}
        changePage={(a) => {
          props.pageNumChange(a);
        }}
        changePageSize={(a) => {
          props.pageSizeChange(a);
        }}
      />
    </>
  );
};
export default TablePage;
